/**
 * @generated SignedSource<<13c49ad5e2fb8280cccb8b01aa757173>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SpaceVisibility = "PRIVATE" | "PUBLIC" | "SECRET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type communitySidebarFragment$data = {
  readonly groups: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
    readonly spaces: ReadonlyArray<{
      readonly icon: string | null | undefined;
      readonly id: string;
      readonly isMember: boolean;
      readonly name: string;
      readonly position: number | null | undefined;
      readonly slug: string;
      readonly visibility: SpaceVisibility;
      readonly " $fragmentSpreads": FragmentRefs<"spaceCreateDialog_spaceFragment" | "spaceDeleteDialogFragment">;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"groupCreateDialog_updateFragment" | "groupDeleteDialogFragment">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"feedReorderDialog_feed" | "spaceCreateDialog_clubFragment">;
  readonly " $fragmentType": "communitySidebarFragment";
};
export type communitySidebarFragment$key = {
  readonly " $data"?: communitySidebarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"communitySidebarFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "communitySidebarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SpaceGroup",
      "kind": "LinkedField",
      "name": "groups",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "spaces",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "icon",
              "storageKey": null
            },
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibility",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isMember",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "position",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "spaceCreateDialog_spaceFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "spaceDeleteDialogFragment"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "groupCreateDialog_updateFragment"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "groupDeleteDialogFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "spaceCreateDialog_clubFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "feedReorderDialog_feed"
    }
  ],
  "type": "Club",
  "abstractKey": null
};
})();

(node as any).hash = "6a46050b7be3ab5fd0ed9aa3b0b31193";

export default node;
